module.exports = __webpack_public_path__ + "img/pin-select.dc1f8800.svg";